import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';
import Typography from '@portalterreno/react-ui-core/Typography';

const Title = styled(Typography)(
  {
    fontSize: 24,
    marginBottom: 0,
    display: 'block',
    textAlign: 'center',
    [media('xs')]: {
      marginTop: 20
    },
    [media('lg')]: {
      marginTop: 0
    }
  },
  ({ theme }) => ({
    color: theme.palette.colors.midnightBlue
  })
);

export default Title;
